import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { CoreComponent } from "../../../../framework/component/index";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { ButtonToolbar, OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "../../../../config/i18n";
import ComponentFactory from "../../../../framework/factory/ComponentFactory";

export class CustomerDateComponent extends CoreComponent {
  static className = "CustomerDateComponent";
  select;

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      requiredInValid: false,
      display_value: props.DefaultValue || "",
    };
  }

  /**
   * Converte data brasileira (DD/MM/YYYY) para formato interno (YYYY-MM-DD)
   * @param {string} brazilianDate - Data no formato DD/MM/YYYY
   * @returns {string} - Data no formato YYYY-MM-DD ou string vazia
   */
  convertBrazilianToInternal(brazilianDate) {
    if (!brazilianDate) return "";

    // Se já está no formato YYYY-MM-DD, retorna como está
    if (brazilianDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return brazilianDate;
    }

    // Se está no formato DD/MM/YYYY, converte
    if (brazilianDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      const parts = brazilianDate.split("/");
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];

      const internalFormat = `${year}-${month}-${day}`;

      // Valida se a data é válida
      const momentDate = moment(internalFormat, "YYYY-MM-DD", true);
      if (momentDate.isValid()) {
        return internalFormat;
      }
    }

    return "";
  }

  /**
   * Converte data interna (YYYY-MM-DD) para formato brasileiro (DD/MM/YYYY)
   * @param {string} internalDate - Data no formato YYYY-MM-DD
   * @returns {string} - Data no formato DD/MM/YYYY ou string vazia
   */
  convertInternalToBrazilian(internalDate) {
    if (!internalDate) return "";

    const momentDate = moment(internalDate, "YYYY-MM-DD", true);
    if (momentDate.isValid()) {
      return momentDate.format("DD/MM/YYYY");
    }

    return "";
  }

  /**
   * validate
   */
  validate() {
    let { Required } = this.props;
    let validate = Required && !this.state.display_value;
    this.setState({
      requiredInValid: validate,
    });

    return validate;
  }

  /**
   * onchange date
   * @param date
   */
  onChangeDate = (date) => {
    let momentDate = moment(date);
    if (!momentDate.isValid()) return;

    const internalDateValue = momentDate.format("YYYY-MM-DD");
    const displayDateValue = momentDate.format("DD/MM/YYYY");

    this.setState(
      {
        display_value: displayDateValue,
      },
      () => this.validate()
    );

    if (this.props.onSelect) {
      this.props.onSelect(this.props.Code, internalDateValue);
    }
  };

  /**
   * onclick show message error
   */
  onClickShowMessageError() {
    this.setState({ showMessageInValid: true });
  }

  template() {
    let classHiddenRequired = "";
    let classRequired = "hidden";
    let { Label, IsOptional, OneRow } = this.props;
    let { requiredInValid, display_value } = this.state;

    let messageError = "";
    if (requiredInValid === true) {
      messageError = "This is a required field";
      classRequired = "validation-advice";
    }

    const popoverRight = (
      <Popover id="popover">
        <div>{i18n.translator.translate(messageError)}</div>
      </Popover>
    );

    return (
      <div className={OneRow ? "col-sm-12" : "col-sm-6"}>
        <label className="block-title">
          {Label}
          {IsOptional ? (
            <Fragment>
              <i>{i18n.translator.translate(" - Optional")}</i>
            </Fragment>
          ) : (
            ""
          )}
        </label>

        <div
          id={"form-date-customer"}
          className={"select-date active"}
        >
          {/* <div className="select-delivery-label">
            {i18n.translator.translate("Selecione uma data")}
          </div> */}

          <Datetime
            id={"datepicker-dob"}
            className={"value"}
            timeFormat={false}
            dateFormat="DD/MM/YYYY"
            value={display_value}
            onChange={this.onChangeDate}
            readOnly={true}
            closeOnSelect
            ref={(ref) => {
              this.dateInputRef = ref;
            }}
          />
        </div>

        <ButtonToolbar className={classRequired}>
          <OverlayTrigger
            trigger={["click", "hover", "focus"]}
            rootClose
            placement="bottom"
            overlay={popoverRight}
            container={this}
          >
            <span
              className={"dropdown-toggle" + classHiddenRequired}
              onClick={this.onClickShowMessageError.bind(this)}
            >
              {" "}
            </span>
          </OverlayTrigger>
        </ButtonToolbar>
      </div>
    );
  }
}

CustomerDateComponent.propTypes = {
  Label: PropTypes.string,
  Required: PropTypes.bool,
  OneRow: PropTypes.bool,
  Code: PropTypes.string,
  DefaultValue: PropTypes.string,
  onSelect: PropTypes.func,
};

/**
 * CustomerDateComponent
 */
export default ComponentFactory.get(CustomerDateComponent);



// WEBPACK FOOTER //
// ./src/view/component/customer/field/CustomerDateComponent.js